module.exports = __webpack_public_path__ + "img/footer-logo-vn.1faecef1.png";